class RecruitJs {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
    // 事業スライダー
    const imageEle = document.querySelector('.js-recruit-business-swiper');
    const textEle = document.querySelector('.js-recruit-business-text-swiper');
    if(imageEle && textEle){
      this.businessSwiper(imageEle,textEle);
    }
  }
  event() {

  }
  businessSwiper(imageEle,textEle) {
    const imageSwiper = new Swiper(imageEle,{
      slidesPerView: 'auto',
      spaceBetween: 20,
      speed: 1000,
      autoplay: {
        delay: 3000
      },
      breakpoints: {
        769: {
          spaceBetween: 60,
        }
      }
    })
    const textSwiper = new Swiper(textEle,{
      slidesPerView: 'auto',
      speed: 1000,
      effect: 'fade',
      allowTouchMove: false,
      fadeEffect: {
        crossFade: true
      },
    })

    imageSwiper.controller.control = textSwiper;
    textSwiper.controller.control = imageSwiper;

    gsap.to({}, {
      scrollTrigger: {
        trigger: imageEle,
        start: 'top bottom',
        onEnter: () => {
          imageSwiper.params.autoplay = {
            delay: 3000,
          };
          imageSwiper.autoplay.start();
        },
      },
    });
  }
  businessTextSwiper(swiperEle) {
  }
}
